// extracted by mini-css-extract-plugin
export default {"fallback":"FallBackUI_fallback__990eX","rotator":"FallBackUI_rotator__2RTLh"};